import { captureException } from '@sentry/react';

export function logMessage(error, tags = {}, data, level = 'error') {
    captureException(error, {
        tags,
        extra: data,
        level,
    });
}
